var calculatorElementsLOC = {};
var calculatorSenderLOC = {};

window.addEventListener('message', function(a){
    try{
        var parsedData = JSON.parse(a.data);
        if(parsedData.origin === "dfg" && parsedData.action === "formSaved" && parsedData.type === "redirect"){
            var gaFilter = dataLayer.filter(function(item){
                return item.user && item.user.ga_client_id;
            });
            if(gaFilter.length > 0){
                window.sessionStorage.setItem(gaFilter[0].user.ga_client_id, calculatorSenderLOC.loanAmount + "_" + calculatorSenderLOC.term + "_" + calculatorSenderLOC.frequency);
            }
        }
    }catch(e){
        // Do nothing
    }
});


var calculatorEventsLOC = {
    EventAction_ClientRequestedAmount: 'loan amount',
    Initialize: function(){
        calculatorEventsLOC.Calculate(calculatorSenderLOC.frequency, calculatorSenderLOC.loanAmount, calculatorSenderLOC.term, calculatorSenderLOC.amountWithdrawn);
        jQuery('#calculator-term-dropdown-loc').change(function() {
            calculatorChangeTermsLOC(this.value);
        });
        jQuery('#calculator-interest-rate-input-loc').change(function() {
            calculatorChangeTermsLOC(this.value);
        });
    },
    Calculate: function(frequency, loanAmount, terms, amountWithdrawn){

        var instalments = calculatorGetNumberOfInstallmentsLOC(terms, frequency)
        let weeklyInstalments = instalments.instalment;

        // Constants
        const facilityLimit = parseInt(loanAmount);
        const balanceWithdrawn = amountWithdrawn;
        const apr = 31 / 100; // Fixed APR of 31%
        const weeklyServiceFee = facilityLimit * 0.00046; // Service fee based on facility limit
        const totalWeeks = weeklyInstalments;
        const totalYears = totalWeeks / 52;
        var allTabs = jQuery(".tab");

        // Initialize variables
        let currentBalance = parseInt(balanceWithdrawn);

        // Perform weekly calculations and populate table split into 5 sections (5 years)
        var currentYear = 0;
        gridData = [];
        gridData[0] = [];
        gridData[1] = [];
        gridData[2] = [];
        gridData[3] = [];
        gridData[4] = [];

        var numberOfRepayments = 0;

        for (let week = 1; week <= totalWeeks; week++) {

            const startingBalance = currentBalance; // Balance at the start of the week
            const interest = Math.max((Math.pow(1 + apr / 365, 7) - 1) * startingBalance, 0); // Weekly interest
            // const principal = startingBalance > 0 ? Math.max(startingBalance * 0.01, 0) : 0; // Principal repayment
            var principal = startingBalance;

            if (startingBalance >= 50) {
                principal = week !== totalWeeks
                    ? Math.max(startingBalance * 0.01, 50) // 1% of Balance or $50 minimum
                    : startingBalance * 0.01; // Last week, exactly 1% of Balance
            }

            const repaymentAmount = interest + principal + weeklyServiceFee; // Total repayment amount
            currentBalance -= principal; // Update the current balance after repayment

            const repaymentAmountFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(repaymentAmount);
            const interestFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(interest);
            const principalFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(principal);
            const weeklyServiceFeeFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(weeklyServiceFee);
            const startingBalanceFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(startingBalance);
            const currentBalanceFormatted = "$" + new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(currentBalance);

            let item = {
                "week": week,
                "repaymentAmount": repaymentAmountFormatted,
                "interest": interestFormatted,
                "principal": principalFormatted,
                "weeklyServiceFee": weeklyServiceFeeFormatted,
                "startingBalance": startingBalanceFormatted,
                "balanceWithdrawn": currentBalanceFormatted,
            };

            gridData[currentYear].push(item);

            if (week % 52 === 0) {
                currentYear ++;
            }

            if (++numberOfRepayments >= 10 && currentBalance > 0) {
                gridData[currentYear].push({
                    "week": "...",
                    "repaymentAmount": "...",
                    "interest": "...",
                    "principal": "...",
                    "weeklyServiceFee": "...",
                    "startingBalance": "...",
                    "balanceWithdrawn": "...",
                });
                jQuery('.first-10-weeks').show();
                break;
            }

            if (currentBalance <= 0) {
                jQuery('.first-10-weeks').hide();
                break;
            }

        }

        // Make sure only tabs that match number of years are visible
        allTabs.hide();

        if (gridData[1].length === 0) {
            jQuery(".tab.tab--year-1").show();
        } else if (gridData[2].length === 0) {
            jQuery(".tab.tab--year-1").show();
            jQuery(".tab.tab--year-2").show();
        } else if (gridData[3].length === 0) {
            jQuery(".tab.tab--year-1").show();
            jQuery(".tab.tab--year-2").show();
            jQuery(".tab.tab--year-3").show();
        } else if (gridData[4].length === 0) {
            jQuery(".tab.tab--year-1").show();
            jQuery(".tab.tab--year-2").show();
            jQuery(".tab.tab--year-3").show();
            jQuery(".tab.tab--year-4").show();
        } else {
            allTabs.show();
        }

        // Load the data into 5 jsGrid tables - one for each year
        jQuery("#jsGridYear1").jsGrid("option", "data", gridData[0]);
        jQuery("#jsGridYear2").jsGrid("option", "data", gridData[1]);
        jQuery("#jsGridYear3").jsGrid("option", "data", gridData[2]);
        jQuery("#jsGridYear4").jsGrid("option", "data", gridData[3]);
        jQuery("#jsGridYear5").jsGrid("option", "data", gridData[4]);

        jQuery('.jsgrid-header-row').show();

        if (instalments) {
            // Get first weeks repayment amount
            document.getElementById("instalmentAmountLOC").innerText = gridData[0][0]['repaymentAmount'];
            /*document.getElementById("instalmentAmountLOC").innerText = '$' + (+weeklyServiceFee).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });*/
        }

    },
    OnRangeChange: function(loanAmount){
        calculatorElementsLOC.loanDisplay.value = '$' + (+loanAmount).toLocaleString();
        document.getElementById("calculator-sender-loc.loanAmount").value = loanAmount;
        calculatorEventsLOC.Calculate(calculatorSenderLOC.frequency, loanAmount, calculatorSenderLOC.term, calculatorSenderLOC.amountWithdrawn);
    },
    LoanAmountValidation: function(){
        var isValid = true;
        if(calculatorSenderLOC.loanAmount){
            var loanAmount = parseInt(calculatorSenderLOC.loanAmount);
            if (loanAmount < minLoanAmountLOC || loanAmount > maxLoanAmountLOC){
                calculatorSenderLOC.loanAmount = 0;
                isValid = false;
            }
        } else{
            calculatorSenderLOC.loanAmount = 0;
            isValid = false;
        }
        calculatorEventsLOC.ShowHideErrorMessage(isValid);
        calculatorEventsLOC.Calculate(calculatorSenderLOC.frequency, calculatorSenderLOC.loanAmount, calculatorSenderLOC.term, calculatorSenderLOC.amountWithdrawn);
    },
    OnTermsChange: function(terms){
        document.getElementById("calculator-sender-loc.term").value = terms;
        calculatorEventsLOC.Calculate(calculatorSenderLOC.frequency, calculatorSenderLOC.loanAmount, calculatorSenderLOC.term, calculatorSenderLOC.amountWithdrawn);
    },
    ShowHideErrorMessage: function(isValid){
        if(!isValid){
            calculatorElementsLOC.loanDisplay.classList.add("invalid-amount");
            calculatorElementsLOC.loanError.classList.remove("invalid-feedback");
        }else{
            calculatorElementsLOC.loanDisplay.classList.remove("invalid-amount");
            calculatorElementsLOC.loanError.classList.add("invalid-feedback");
        }
    }
};
document.addEventListener("DOMContentLoaded", function() {

    var calculatorLoanRange = document.querySelector(".calculator-form--loc.prad--form");

    if  (calculatorLoanRange) {

        var loanDisplay = document.getElementById("calculator-loan-display-loc");
        var loanError = document.getElementById("calculator-loan-error-loc");
        var termDropdown = document.getElementById("calculator-term-dropdown-loc");
        var calculateButton = document.getElementById("calculator-calculate-button-loc");
        var amountWithdrawnField = document.getElementById("calculator-amount-withdrawn-loc");

        calculatorElementsLOC = {
            loanDisplay: loanDisplay,
            loanError: loanError,
            termDropdown: termDropdown
        };

        calculatorSenderLOC = {
            loanAmount: document.getElementById("calculator-sender-loc.loanAmount").value,
            term: document.getElementById("calculator-sender-loc.term").value,
            frequency: document.getElementById("calculator-sender-loc.frequency").value,
            amountWithdrawn: document.getElementById("calculator-amount-withdrawn-loc").value
        };

        loanDisplay.onkeydown = function(e){
            var validKeyCode = [8, 13, 37, 38, 39, 40, 46];
            if((isNaN(e.key) && validKeyCode.indexOf(e.keyCode) === -1)){
                e.preventDefault(e);
            }
            else if(loanDisplay.value.length === 8 && validKeyCode.indexOf(e.keyCode) === -1) {
                e.preventDefault(e);
            }
        };

        loanDisplay.onkeyup = function(e){
            calculatorSenderLOC.loanAmount = this.value.replace(/\D/g,'');
            calculatorFormatCurrencyLOC(this);
            calculatorEventsLOC.LoanAmountValidation();
            var learnMore = document.querySelector(".cta-button.cta-button--learn-more");
            if (learnMore) {
                learnMore.setAttribute('data-amount', calculatorSenderLOC.loanAmount);
                regenerateLearnMoreLink();
            }
        };

        loanDisplay.onchange = function(){
            calculatorSenderLOC.loanAmount = this.value.replace(/\D/g,'');
            calculatorFormatCurrencyLOC(this, "blur");
            calculatorEventsLOC.LoanAmountValidation();
            if(loanDisplay.value === "" || loanDisplay.value === "$"){
                loanDisplay.value = "$0";
            }
        };

        calculateButton.onclick = function(){
            calculatorEventsLOC.Initialize();
            document.querySelector('.calculator-form--loc .result-bar').classList.remove('d-none');
            // document.querySelector('.calculator-form--loc .result-bar-text-under').classList.remove('d-none');
            document.getElementById("repayment-breakdown-loc").classList.remove('hide');
            document.querySelector('.cta-button-container-loc').classList.remove('d-none');
        };

        amountWithdrawnField.onkeyup = function(e){
            var cleanValue = this.value.replace(/\D/g,'');

            if (cleanValue === '') {
                cleanValue = '0';
                this.value = '$0';
            }

            if (parseInt(cleanValue) > calculatorSenderLOC.loanAmount) {
                cleanValue = calculatorSenderLOC.loanAmount;
                this.value = '$' + cleanValue;
            }

            calculatorSenderLOC.amountWithdrawn = cleanValue;
            calculatorEventsLOC.Initialize();
            calculatorFormatCurrencyLOC(this);
            var tabYear1 = document.querySelector('.tab--year-1');
            if (tabYear1) {
                tabYear1.dispatchEvent(new Event("click"));
                jQuery('#jsGridYear1').jsGrid('reset');
            }

            var learnMore = document.querySelector(".cta-button.cta-button--learn-more");
            if (learnMore) {
                learnMore.setAttribute('data-drawdown', cleanValue);
                regenerateLearnMoreLink();
            }

        };

        amountWithdrawnField.onchange = function() {
            calculatorEventsLOC.Initialize();
            calculatorFormatCurrencyLOC(this, "blur");
        };

        amountWithdrawnField.dispatchEvent(new Event("change"));
    }

    function regenerateLearnMoreLink()
    {
        var learnMore = document.querySelector(".cta-button.cta-button--learn-more");
        var heroButton = document.querySelector(".cta-button.cta-button--calculator-hero");
        var originalURL = learnMore.getAttribute('data-url');
        var newAmount = learnMore.getAttribute('data-amount');
        var newDrawDown = learnMore.getAttribute('data-drawdown');
        var tNCHash = heroButton.getAttribute('data-hash') ? heroButton.getAttribute('data-hash') : '';
        learnMore.href= originalURL + '?amount=' + newAmount + '&' + 'drawdown=' + newDrawDown + '#loc';
        heroButton.href= originalURL + '?amount=' + newAmount + '&' + 'drawdown=' + newDrawDown + tNCHash;
    }

});

function calculatorChangeTermsLOC(value){
    calculatorSenderLOC.term = value;
    calculatorEventsLOC.OnTermsChange(value);
}
function calculatorGetNumberOfInstallmentsLOC(terms, frequency){
    var lookup = calculatorFilterArrayByKeyLOC(instalmentsLookup, "frequency", frequency);
    return calculatorFindObjectByKeyLOC(lookup, "instalment", terms);
}
function calculatorFilterArrayByKeyLOC(array, key, value){
    var result = [];

    for(var i = 0; i< array.length; i++){
        if(array[i][key].toLocaleString() === value.toLocaleString()){
            result.push(array[i]);
        }
    }
    return result;
}
function calculatorFindObjectByKeyLOC(array, key, value){
    for(var i = 0; i< array.length; i++){
        if(array[i][key].toLocaleString() === value.toLocaleString()){
            return array[i];
        }
    }
    return null;
}
function calculatorFormatCurrencyLOC(input, blur) {

    var input_value = input.value;
    // Do not validate if empty
    if (input_value === ""){
        return;
    }
    var original_len = input_value.length;
    var caret_pos = input.selectionStart;
    // check for decimal place
    var decimal_pos = input_value.indexOf(".");
    if (decimal_pos >= 0){
        var left_side = input_value.substring(0, decimal_pos);
        var right_side = input_value.substring(decimal_pos);

        left_side = calculatorFormatNumberLOC(left_side);
        right_side = calculatorFormatNumberLOC(right_side);
        if (blur === "blur") {
            right_side += "00";
        }
        // Limit decimal to only 2 digits
        right_side = right_side.substring(0, 2);
        // join number by .
        input_val = "$" + left_side + "." + right_side;
    } else {
        input_value = calculatorFormatNumberLOC(input_value);
        input_value = "$" + input_value;
    }
    if(input_value.length > 2 && input_value[1] === "0"){
        input_value = input_value.replace("0", "");
    }
    input.value = input_value;
    // put caret back in the right position
    var updated_len = input_value.length;
    caret_pos = updated_len - original_len + caret_pos;
    input.selectionStart = caret_pos;
    input.selectionEnd = caret_pos;
}

function calculatorFormatNumberLOC(n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}